module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-add-attributes"
  }, _vm._l((_vm.quickAddAttributes), function(attribute) {
    return _c('button', {
      key: attribute.id,
      ref: "button",
      refInFor: true,
      class: {
        'is-active': _vm.isActive(attribute)
      },
      on: {
        "click": function($event) {
          return _vm.attributeClickedHandler(attribute, $event)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getPrettyName(attribute)) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-691934e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/quickAddAttributes/QuickAddAttributes.vue
// module id = 1931
// module chunks = 0